import { render, staticRenderFns } from "./EditQuestionPage.vue?vue&type=template&id=4e11a6fb&"
import script from "./EditQuestionPage.vue?vue&type=script&lang=ts&"
export * from "./EditQuestionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports